document.addEventListener('DOMContentLoaded', function() {
const wrapper = document.querySelector('.brand-dropdown-wrapper');
const toggle = wrapper.querySelector('.brand-dropdown-toggle');
const menu = wrapper.querySelector('.brand-dropdown-menu');

toggle.addEventListener('click', function() {
    const isOpen = wrapper.classList.contains('open');

    if (isOpen) {
    menu.style.maxHeight = 0;
    menu.style.opacity = 0;
    wrapper.classList.remove('open');
    } else {
    menu.style.maxHeight = menu.scrollHeight + 'px';
    menu.style.opacity = 1;
    wrapper.classList.add('open');
    }
});

document.addEventListener('click', function(e) {
    if (!wrapper.contains(e.target)) {
    menu.style.maxHeight = 0;
    menu.style.opacity = 0;
    wrapper.classList.remove('open');
    }
});
});

document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector(".brand-navigation");
  const progress = document.querySelector(".brand-scroll-progress");

  if (!nav || !progress) return;

  nav.addEventListener("scroll", function () {
    const maxScroll = nav.scrollWidth - nav.clientWidth;
    const percent = nav.scrollLeft / maxScroll;

    progress.style.width = percent * 100 + "%";
  });
});